var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProgressBarFilledStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-7{fill:none;}.cls-2{clip-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#fff;}.cls-6{clip-path:url(#clip-path-3);}.cls-7{stroke:#fd1a50;stroke-miterlimit:10;stroke-width:4px;}.cls-8{clip-path:url(#clip-path-5);}.cls-9{clip-path:url(#clip-path-6);}.cls-10{fill:#fe154b;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-243.92 -211.62)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 257.92,
    cy: 225.62,
    r: 9.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-243.92 -211.62)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.92,
    y: 15.62,
    width: 375,
    height: 798
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-243.92 -211.62)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.92,234.62a9,9,0,1,0-9-9A9,9,0,0,0,257.92,234.62Zm-21-30h42v42h-42Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(-243.92 -211.62)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "257.92 229.3 262.25 231.91 261.1 226.99 264.92 223.68 259.89 223.26 257.92 218.62 255.96 223.26 250.92 223.68 254.75 226.99 253.6 231.91 257.92 229.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(-243.92 -211.62)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 403.85,
    height: 859.38
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "filled_star") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 28,
    height: 28
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 14,
    cy: 14,
    r: 9
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1.62,
    y: 1.62,
    width: 24.77,
    height: 24.07
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressBarFilledStar);
export default __webpack_public_path__ + "static/media/progress_bar_filled_star.ce0f1b6a7f6990f0cb847445b3e81536.svg";
export { ForwardRef as ReactComponent };